<script lang="ts">
	import RightIcon from '$lib/components/Icon/RightIcon.svelte';
	import KnownFromIcons from '$lib/components/Icon/SignUp/KnownFromIcons.svelte';
	import { classes } from '$lib/utils';
	import { getTranslate } from '@tolgee/svelte';
	import { createEventDispatcher, onMount } from 'svelte';

	const { t } = getTranslate();
	const dispatch = createEventDispatcher();

	export let title: string;
	export let icon: string;
	export let additionalClass = '';

	let buttonRef: HTMLButtonElement;

	function handleSelect() {
		buttonRef.blur();
		dispatch('select');
	}

	onMount(() => {
		console.log(`Mounted SelectionItem with title: ${title}`);
	});
</script>

<button
	bind:this={buttonRef}
	class={classes(
		additionalClass,
		'flex items-center justify-between p-4 gap-6 bg-white shadow-sm shadow-slate-50 hover:bg-purple-50 ring-purple focus:outline-none focus:ring-2 focus:ring-offset-2'
	)}
	on:click={handleSelect}
	on:keydown
	{...$$restProps}
>
	<div class="flex flex-row gap-4 place-items-center">
		<div class="min-w-12 min-h-12"><KnownFromIcons type={icon} /></div>
		<span>{title}</span>
	</div>
	<div class="min-w-[6px] min-h-[8px]"><RightIcon /></div>
</button>
